import { defineStore } from "pinia";
// import api from "@/plugins/axios";
// import router from "@/router";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: {},
    tenant: {},
  }),
  actions: {
    setUser(user) {
      localStorage.setItem("user_data", JSON.stringify(user));
      this.user = user;
    },

    setToken(token) {
      localStorage.setItem("user_token", token);
    },

    loadUser() {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (user) {
        this.user = user;
      }
    },

    setTenant(tenant) {
      localStorage.setItem("user_tenant", JSON.stringify(tenant));
      this.tenant = tenant;
    },
    loadTenant() {
      const tenant = JSON.parse(localStorage.getItem("user_tenant"));
      if (tenant) {
        this.tenant = tenant;
      }
    },

    removeAuthData() {
      localStorage.removeItem("user_data");
      localStorage.removeItem("user_token");
      this.user = {};
    },
  },
});
